module.exports = "<div class=\"pane-title\">\n    <span class=\"glyphicon glyphicon-pencil\"></span>\n    {{ name }}\n</div>\n<div id=\"{{ id }}\"></div>\n"